import { useCallback } from 'react';
import { securedSupabase } from '@/integrations/supabase/secured-client';
import { logger } from '@/utils/logger';

export const useVehicleInterest = () => {
  const insertVehicleInterest = useCallback(async (
    sessionId: string,
    dealerId: number,
    vehicle: string,
    source: 'Site' | 'Chat' | 'AI',
    siteUrl?: string
  ) => {
    try {
      logger.log('Inserting vehicle interest:', { sessionId, dealerId, vehicle, source, siteUrl });
      
      // Use base supabase client to avoid dealer context headers interfering with edge functions
      const { supabase } = await import('@/integrations/supabase/client');
      
      const { data, error } = await supabase.functions.invoke('vehicle-interest', {
        body: {
          action: 'insert',
          session_id: sessionId,
          dealer_id: dealerId,
          vehicle,
          source,
          site_url: siteUrl
        }
      });

      if (error) {
        logger.error('Error inserting vehicle interest:', error);
        return null;
      }

      logger.log('Successfully inserted vehicle interest:', data);
      return (data as any)?.data ?? null;
    } catch (error) {
      logger.error('Failed to insert vehicle interest:', error);
      return null;
    }
  }, []);

  const getVehicleInterests = useCallback(async (sessionId: string, dealerId: number) => {
    try {
      // Use base supabase client to avoid dealer context headers interfering with edge functions
      const { supabase } = await import('@/integrations/supabase/client');
      
      const { data, error } = await supabase.functions.invoke('vehicle-interest', {
        body: {
          action: 'list',
          session_id: sessionId,
          dealer_id: dealerId
        }
      });

      if (error) {
        logger.error('Error fetching vehicle interests:', error);
        return [];
      }

      return ((data as any)?.data as any[]) || [];
    } catch (error) {
      logger.error('Failed to fetch vehicle interests:', error);
      return [];
    }
  }, []);

  return {
    insertVehicleInterest,
    getVehicleInterests
  };
};